import React, { useState, useEffect } from "react";
import {
    Drawer,
    Form,
    Input,
    Button,
    Space,
    InputNumber,
    message,
    Popconfirm,
    Descriptions,
    Divider,
    Select,
    Row,
    Col,
} from "antd";
import { useDispatch } from "react-redux";
import { updateVariation, deleteVariation } from "../../../actions/variableProductAction";

const { TextArea } = Input;
const { Option } = Select;

const StockVariation = ({ visible, onClose, details, onSuccess }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (visible && details) {
      form.setFieldsValue({
        quantity: details.quantity || 0,
        selling_price: details.selling_price || 0,
        description: details.description || "",
        batch_no: details.batch_no || "",
        Attribute_details: details.Attribute_details || "",
      });
    }
  }, [visible, details, form]);

  const handleUpdate = async (values) => {
    setLoading(true);
    try {
    const formData = {
    quantity: values.quantity,
    selling_price: values.selling_price,
    description: values.description,
    batch_no: values.batch_no,
    Attribute_details: values.Attribute_details,
    ProductDetails: typeof details.ProductDetails === 'object' ? details.ProductDetails.id : details.ProductDetails,
    Warehouse: typeof details.Warehouse === 'object' ? details.Warehouse.id : details.Warehouse,
    };

      await dispatch(updateVariation(details.id, formData));
      message.success("Stock variation updated successfully");
      form.resetFields();
      onClose();
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      message.error("Failed to update stock variation");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      await dispatch(deleteVariation(details.id));
      message.success("Variation deleted successfully");
      form.resetFields();
      onClose();
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      message.error("Failed to delete variation");
      console.error(error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Drawer
      title="Update Stock Variation"
      width={800}
      onClose={handleCancel}
      visible={visible}
      bodyStyle={{ paddingBottom: 0 }}
    >
      {details && (
        <>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Product Name">
              {details.product_code || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Category">
              {details.category || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Barcode">
              {details.barcode || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Location">
              {details.Warehouse_name || "N/A"}
            </Descriptions.Item>
          </Descriptions>

        < Divider />
            <Form
            form={form}
            layout="vertical"
            onFinish={handleUpdate}
            autoComplete="off"
            >
                <Row gutter={16}>
                    <Col xs={24} sm={12}>
                    <Form.Item
                        name="Attribute_details"
                        label="Variation/Attributes"
                    >
                        <Input placeholder="Enter variation/attribute details" />
                    </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                    <Form.Item
                        name="batch_no"
                        label="Batch No"
                    >
                        <Input placeholder="Enter batch number" maxLength={255} />
                    </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} sm={12}>
                    <Form.Item
                        name="quantity"
                        label="Quantity"
                        rules={[
                        { required: true, message: "Please input quantity!" },
                        { type: "number", min: 0, message: "Quantity must be 0 or more" },
                        ]}
                    >
                        <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Enter quantity"
                        min={0}
                        />
                    </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                    <Form.Item
                        name="selling_price"
                        label="Selling Price"
                        rules={[{ required: true, message: "Please input selling price!" }]}
                    >
                        <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Enter selling price"
                        min={0}
                        step={0.01}
                        precision={2}
                        />
                    </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                    <Form.Item name="description" >
                        <TextArea
                        rows={3}
                        placeholder="Enter description"
                        maxLength={2000}
                        showCount
                        />
                    </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Space style={{ width: "100%", justifyContent: "space-between" }}>
                    <Space>
                        <Button onClick={handleCancel}>Cancel</Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                        Update
                        </Button>
                    </Space>

                    <Popconfirm
                        title="Are you sure you want to delete this variation?"
                        description="This action cannot be undone."
                        onConfirm={handleDelete}
                        okText="Yes"
                        cancelText="No"
                        okButtonProps={{ danger: true }}
                    >
                        <Button type="primary" danger loading={deleteLoading}>
                        Delete Variation
                        </Button>
                    </Popconfirm>
                    </Space>
                </Form.Item>
            </Form>

        </>
      )}
    </Drawer>
  );
};

export default StockVariation;